import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import './HandSimulator.css'
import { apiService } from '../../common/apiCallService';
import { baseUrl } from '../../common/config';
import Loading from '../Loading';
import moment from "moment";
import { InputDatePicker } from 'mygame-components';
import $ from 'jquery';

class HandSimulator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Hand Simulator',
      successFlag: "",
      partialCompletion: false,
      msg: "",
      gameTypes: ["cash", "tournament", "spin", "SnG"],
      gameSubTypes: ["Texas Holdem", "Omaha Hi"],
      ringTypes: ["Heads-up", "6-seater", "Full Ring"],
      events: [
        "first_hand",
        "win_first_hand",
        "win_big_pot",
        "passively_losing_25plusBB",
        "advised_starting_hand_winning_25plusBB",
        "lose_big_pot",
        "unadvised_starting_hand_losing25plusBB",
        "win_flip",
        "lose_flip",
        "got_money_ahead_won",
        "got_outdrawn_big_pot",
        "that_was_lucky",
        "skill_level",
        "skill_level_up",
        "skill_level_down",
        "playing_too_passively",
        "playing_too_many_hands",
        "all_in_hands",
        "mission_invite_starting_hands",
        "raised_advised_hands",
        "raised_unadvised_hands",
        "cash_gto",
        "wellplayed",
        "cbet_size",
        "booster",
        "3bet_sizing_hint",
        "preflop_limp",
        "unopened_button_limp",
        "unopened_button_raise",
        "spins_isolation_raise_betsize",
        "MTT_gto_30_50BB",
        "spins_won_tournament",
        "Facing One Raiser 50-80BB",
        "Facing One Raiser 30-50BB",
        "Unopened Scenarios 15-30BB",
        "Unopened Scenarios 50-80BB",
        "Report-PLO",
        "Report-fullring",
        "report-6-seater",
        "Report-fullring",
        "Report-PLO-CCY",
        "Report-PLO-CCY",
        "Report-fullring-CCY",
        "report-6-seater-CCY",
        "Report-fullring-CCY",
        "Report-PLO-CCY",
        "TestHands"
      ],
      gameType: "cash",
      gameSubType: "Texas Holdem",
      ringType: "6-seater",
      event: "first_hand",
      bkp_table: "simulator_hands",
      rowHandsTable: "raw_hands",
      alias: "Badbeat",
      accountName: "pp_he4ther",
      databaseName: "PP_Dev_Data",
      databaseNameProd: "PP_Dev_Data",
      limit: 25,
      publisher_token: "sdfhADSLFJKWersadf24728323QEUIEsfasddf",
      mongoDeleteCount: 0,
      redisDeleteCount: 0,
      clearData: "",
      mongoEventsDeleteCount: 0,
      realHands: false,
      handsDelay: 1,
      delayError: "",
      partitionDate: moment().startOf("day"),
      tempPartitionDate: moment().startOf("day"),
      partitionDateError: "",
      limitError: "",
    }
  }

  componentDidMount = () => {
    if(localStorage.getItem("alias")) {
      this.setState({alias: localStorage.getItem("alias")})
    }
    if(localStorage.getItem("accountName")) {
      this.setState({accountName: localStorage.getItem("accountName")})
    }
  }  

  clearAllDataForToday = () => {
    this.setState({ clearData: "", successFlag: "", loading: true, mongoDeleteCount: 0, redisDeleteCount: 0, mongoEventsDeleteCount: 0 })
    apiService(baseUrl + '/simulator/clearAllDataForToday', {
      gameType: this.state.gameType,
      replaceAccountName: this.state.realHands ? localStorage.getItem('accountName') : this.state.accountName,
    }, (data) => {
      localStorage.setItem("refreshOnClearData", this.state.gameType);
      this.setState({
        clearData: "success",
        loading: false,
        mongoDeleteCount: data.mongoDeleteCount,
        redisDeleteCount: data.redisDeleteCount,
        mongoEventsDeleteCount: data.mongoEventsDeleteCount,
      })
    }, (data) => {
      this.setState({
        clearData: "failed",
        loading: false,
      })
    })
  }

  simulate = () => {
    this.setState({ clearData: "", successFlag: "", msg: "", delayError: "", limitError: "" , partialCompletion: false, loading: true })
    if (this.state.handsDelay < 1) {
      this.setState({ delayError: "Delay must be greater than equeal to 1 second", loading: false })
    } else if (this.state.realHands && moment(moment(this.state.partitionDate).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment().startOf("day"))) {
      this.setState({ partitionDateError: "Partition Date must not be in feature" })
    } else if (this.state.limit <1) {
      this.setState({ limitError: "Limit must be greater than equal to 1", loading: false })
    } else if (this.state.limit > 25) {
      this.setState({ limitError: "Limit must be less than equal to 25", loading: false })
    } else {
      let body = {};
      if (this.state.realHands) {
        body = {
          realHands: this.state.realHands,
          gameType: this.state.gameType,
          gameSubType: this.state.gameSubType,
          ringType: this.state.ringType,
          bkp_table: this.state.rowHandsTable,
          replaceAlias: localStorage.getItem('alias'),
          replaceAccountName: localStorage.getItem('accountName'),
          databaseName: this.state.databaseNameProd,
          limit: this.state.limit,
          publisher_token: this.state.publisher_token,
          handsDelay: this.state.handsDelay * 1000,
          partitionDate: moment(this.state.partitionDate).format("YYYY-MM-DD HH:mm:ss"),
          sourceUserAlias: this.state.alias,
          sourceUserAccountName: this.state.accountName,
        }
      } else {
        body = {
          realHands: this.state.realHands,
          gameType: this.state.gameType,
          gameSubType: this.state.gameSubType,
          ringType: this.state.ringType,
          event: this.state.event,
          bkp_table: this.state.bkp_table,
          replaceAlias: this.state.alias,
          replaceAccountName: this.state.accountName,
          databaseName: this.state.databaseName,
          limit: this.state.limit,
          handsDelay: this.state.handsDelay * 1000,
          publisher_token: this.state.publisher_token,
        }
      }
      apiService(baseUrl + '/simulator/publishHands', {
        ...body
      }, (data) => {
        this.setState({
          successFlag: data.partialCompletion ? "partial success" : "success",
          msg: data.msg,
          loading: false,
          partialCompletion: data.partialCompletion ? data.partialCompletion : false
        })
      }, (err) => {
        if(err && err.status === 0){
          this.setState({
            successFlag: "request timeout! request is taking too long to complete, still you will get output in pokerwhiz.",
            loading: false
          })  
        } else {
          this.setState({
            successFlag: "failed",
            loading: false
          })
        }
      })
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, delayError: "", limitError: "" })
  }

  handleRadioChange = (currentValue) => {
    this.setState({ realHands: !currentValue, delayError: "", limitError: "" })
  }

  render() {
    this.props.setHeaderTitle(this.state.title);
    return (<div>
      {this.state.loading
        ? <Loading />
        : null}
      <div className="simulator_body_wrap">
        <b><h1>
          Simulate Hands
        </h1></b>
        <div className="simulator_filters_wrap" >
          <div className="SF_wrap">
            <div className="hs_checkBox_wrap">
              <div className="hs_checkbox_width">
                <input type="checkbox" checked={!this.state.realHands}
                  onChange={() => {
                    this.handleRadioChange(this.state.realHands)
                  }} style={{ cursor: "pointer" }}
                  value="None" id="roundedOne" name="realHands" />
                <label style={{ marginLeft: "12px", cursor: "pointer" }} onClick={() => {
                  this.handleRadioChange(this.state.realHands)
                }} >{!this.state.realHands ? " Using Simulator Hands" : " Use Simulator Hands"}</label>
              </div>
              <div className="hs_checkbox_width">
                <input type="checkbox" checked={this.state.realHands}
                  onChange={() => {
                    this.handleRadioChange(this.state.realHands)
                  }} style={{ cursor: "pointer" }}
                  value="None" id="roundedOne2" name="realHands" />
                <label style={{ marginLeft: "12px", cursor: "pointer" }} onClick={() => {
                  this.handleRadioChange(this.state.realHands)
                }} >{this.state.realHands ? " Using Real Hands" : " Use Real Hands"}</label>
              </div>
            </div>
            {this.state.realHands && <div className="SF_wrap_inner" >
              <label>Partiton Date:  {this.state.partitionDateError != "" && <span style={{ color: "red", fontWeight: 500, fontSize: "12px" }}>{this.state.partitionDateError}</span>}</label><br />
              <span id="HandS_partinonDate" data-toggle="modal"
                data-target="#HandSDateTimePicker">
                <input type="teaxt" style={{ cursor: "pointer" }} value={moment(this.state.partitionDate).format("YYYY-MM-DD HH:mm:ss")} name="partitionDate" className="form-control" placeholder="Max number of hands you want to fetch" aria-label="Username" aria-describedby="basic-addon1" />
              </span>
              <InputDatePicker
                modalId="HandSDateTimePicker"
                selectedDate={this.state.tempPartitionDate}
                handleChange={(data) => {
                  this.setState({
                    tempPartitionDate: moment(data).startOf("day"),
                    partitionDateError: "",
                  })
                }}
                handleSave={() => {
                  this.setState({ partitionDate: this.state.tempPartitionDate })
                  if (moment(moment(this.state.tempPartitionDate).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment().startOf("day"))) {
                    this.setState({ partitionDateError: "Partition Date must not be in feature" })
                  }
                  $('#HandS_partinonDate').click();
                }}
              />
            </div>}
            {!this.state.realHands && <div className="SF_wrap" style={{ width: "100%", margin: 0, padding: 0 }}>
            <label>Event:</label><br />
            <select value={this.state.event} name="event" onChange={this.handleChange} className="form-control" style={{ background: '#404040', color: "white" }}>
              {this.state.events.map((data, i) => {
                return <option key={i} value={data}>{data}</option>
              })}
            </select>
          </div>}
          </div>
          <div className="SF_wrap">
            <label>Game Type:</label><br />
            <select value={this.state.gameType} name="gameType" onChange={this.handleChange} className="form-control" style={{ background: '#404040', color: "white" }}>
              {this.state.gameTypes.map((data, i) => {
                return <option key={i} value={data}>{data}</option>
              })}
            </select>
          </div>
          <div className="SF_wrap">
            <label>Game Sub Type:</label><br />
            <select value={this.state.gameSubType} name="gameSubType" onChange={this.handleChange} className="form-control" style={{ background: '#404040', color: "white" }}>
              {this.state.gameSubTypes.map((data, i) => {
                return <option key={i} value={data}>{data}</option>
              })}
            </select>
          </div>
          <div className="SF_wrap">
            <label>Ring Type:</label><br />
            <select value={this.state.ringType} name="ringType" onChange={this.handleChange} className="form-control" style={{ background: '#404040', color: "white" }}>
              {this.state.ringTypes.map((data, i) => {
                return <option key={i} value={data}>{data}</option>
              })}
            </select>
          </div>
          {/* <div className="SF_wrap">
            <label>Backup Table:</label><br/>
            <input type="text" value={this.state.bkp_table} name="bkp_table" onChange={this.handleChange} className="form-control" placeholder="simulator hands tabel" aria-label="Username" aria-describedby="basic-addon1" />
          </div> */}
          {/* <div className="SF_wrap">
            <label>Database Name:</label><br/>
            <input type="text" value={this.state.databaseName} name="databaseName" onChange={this.handleChange} className="form-control" placeholder="Database Name" aria-label="Username" aria-describedby="basic-addon1" />
          </div> */}
          <div className="SF_wrap">
            <label>Alias:</label><br />
            <input type="text" value={this.state.alias} name="alias" onChange={this.handleChange} className="form-control" placeholder="Alias of Player" aria-label="Username" aria-describedby="basic-addon1" />
          </div>
          <div className="SF_wrap">
            <label>Limit: {this.state.limitError != "" && <span style={{ color: "red", fontWeight: 500, fontSize: "12px" }}>{this.state.limitError}</span>}</label><br />
            <input type="number" value={this.state.limit} name="limit" onChange={this.handleChange} className="form-control" placeholder="Max number of hands you want to fetch" aria-label="Username" aria-describedby="basic-addon1" />
          </div>
          <div className="SF_wrap">
            <label>Account Name:</label><br />
            <input type="text" value={this.state.accountName} name="accountName" onChange={this.handleChange} className="form-control" placeholder="Account Name of Player" aria-label="Username" aria-describedby="basic-addon1" />
          </div>
          <div className="SF_wrap">
            <label>Delay Between Hands(Seconds): {this.state.delayError != "" && <span style={{ color: "red", fontWeight: 500, fontSize: "12px" }}>{this.state.delayError}</span>}</label><br />
            <input type="number" min="1" value={this.state.handsDelay} name="handsDelay" onChange={this.handleChange} className="form-control" placeholder="Min hand delay is 1 secons" aria-label="Username" aria-describedby="basic-addon1" />
          </div>

          {/* <div className="SF_wrap">
            <label>Publisher API Token:</label><br/>
            <input type="password" value={this.state.publisher_token} name="publisher_token" onChange={this.handleChange} className="form-control" placeholder="publisher token for dev env" aria-label="Username" aria-describedby="basic-addon1" />
          </div> */}
        </div>
        <div className="sh_control_wrap">
          <div className="clear_wrap" >
            <div className="pub_btn" onClick={(e) => {
              e.preventDefault()
              console.log(e)
              this.clearAllDataForToday()
            }}>Clear Today's Data</div>
          </div>
          <div className="pub_wrap" >
            <div className="pub_btn" onClick={(e) => {
              e.preventDefault()
              console.log(e)
              this.simulate()
            }}>Publish Hands</div>
          </div>
        </div>
        {this.state.successFlag != "" &&
          <div className="resultWrapper"> <h4><b>Publish Hands Result:</b></h4>
            <span style={{ display: "flex" }}> Success Flag:
            <div style={{ color: this.state.successFlag === "success" ? "green" : this.state.successFlag === "partial success" ? "#999900" : "red" }}>&nbsp;{this.state.successFlag}</div>
            </span>
            {this.state.msg != "" && <span style={{ display: "flex" }}> Message:
            <div>&nbsp;{this.state.msg}</div>
            </span>}
          </div>}
        { /* this.state.clearData != "" &&
          <div className="resultWrapper"> <h4><b>Clear data Result:</b></h4>
            <span style={{ display: "flex" }}> Success Flag:
            <div style={{ color: this.state.clearData === "success" ? "green" : "red" }}>&nbsp;{this.state.clearData}</div>
            </span>
            <span style={{ display: "flex" }}> NewHands_MongoDB Delete Count:
            <div>&nbsp;{this.state.mongoDeleteCount}</div>
            </span>
            <span style={{ display: "flex" }}> Player_Events Delete Count:
            <div>&nbsp;{this.state.mongoEventsDeleteCount}</div>
            </span>
            <span style={{ display: "flex" }}> Redis_Reports Delete Count:
            <div>&nbsp;{this.state.redisDeleteCount}</div>
            </span>
          </div>} */}
      </div>
    </div>)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
  }
};

export default connect(null, mapDispatchToProps)(HandSimulator);



/** WEBPACK FOOTER **
 ** ./src/components/HandSimulator/HandSimulator.js
 **/